import clsx from "clsx"
import BodyText from "components/Typography/BodyText"
import { useState } from "react"
import styled from "styled-components"

const Circle = styled.div`
  background-color: ${(props) => props.theme.palette.white};
  border-radius: 50%;
  height: 20px;
  transition: transform 0.3s;
  width: 20px;

  &.isActive {
    transform: translateX(24px);
  }

  &.medium {
    height: 18px;
    width: 18px;

    &.isActive {
      transform: translateX(20px);
    }
  }

  &.small {
    height: 12px;
    width: 12px;

    &.isActive {
      transform: translateX(16px);
    }
  }

  &.disabled {
    background-color: ${(props) => props.theme.palette.white};
  }
`
const SwitchContainer = styled.button`
  align-items: center;
  background-color: ${(props) => props.theme.palette.lightGray};
  border: none;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  height: 24px;
  padding: 2px;
  transition: background-color 0.3s;
  width: 48px;

  &.isActive {
    background-color: ${(props) => props.theme.palette.primary_one};
  }

  &.medium {
    min-width: 47px;
    height: 26px;
    border-radius: 15px;
    padding: 4px;
  }

  &.small {
    width: 32px;
    height: 16px;
    border-radius: 8px;
    padding: 2px;
  }

  &.disabled {
    background-color: ${(props) => props.theme.palette.disabled};
    cursor: not-allowed;
  }
`

const SwitchOuterContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;

  &.medium {
    gap: 8px;
  }

  &.small {
    gap: 8px;
  }

  &.grayBackground {
    padding: 8px;
    height: 56px;
    box-shadow: 0px 0px 4px 0px ${(props) => props.theme.palette.dark_box_shadow};
    background-color: ${(props) => props.theme.palette.gray_ice};
    border-radius: 4px;
  }
`

interface SwitchProps {
  initialState?: boolean
  value?: boolean
  label?: string
  onChange?: (value: boolean) => void
  variant?: "medium" | "small"
  disabled?: boolean
  grayBackground?: boolean
}

const SwitchV2 = (props: SwitchProps) => {
  const { initialState, value, label = "", onChange, variant, disabled, grayBackground = false } = props
  const [isActive, setIsActive] = useState(initialState)

  const handleClick = () => {
    setIsActive(!isActive)

    if (onChange) {
      onChange(!isActive)
    }
  }

  const active = typeof value !== "undefined" ? value : isActive

  return (
    <SwitchOuterContainer className={clsx(variant, { grayBackground })}>
      <SwitchContainer
        type="button"
        onClick={handleClick}
        disabled={disabled}
        className={clsx(variant, { isActive: active, disabled })}
      >
        <Circle className={clsx(variant, { isActive: active, disabled })} />
      </SwitchContainer>
      {!!label && (
        <BodyText size="medium" color={disabled ? "gray-medium" : "primary-dark"} weight="light">
          {label}
        </BodyText>
      )}
    </SwitchOuterContainer>
  )
}

export default SwitchV2
